const ApproverTypeEnumLowercase = {
  none: 'none',
  manager: 'manager',
  user: 'user',
  group: 'group'
};

export { ApproverTypeEnumLowercase };
export default ApproverTypeEnumLowercase;
